const formValidation = {
  'formValidation.minLength': 'Este campo requer no mínimo {min} caractere(s)',
  'formValidation.maxLength': 'Este campo permite no máximo {max} caractere(s)',
  'formValidation.required': 'Campo obrigatório',
  'formValidation.emailInvalid': 'Email inválido',
  'formValidation.phoneInvalid': 'Telefone inválido',
  'formValidation.phoneCount': 'Você pode adicionar até {max} telefones',
  'formValidation.minValue': 'O valor minimo é {min}',
  'formValidation.lengthAtLeast':
    'Este campo requer no mínimo {arg} caractere(s)',
  'formValidation.shouldContain-upperCase':
    'Este campo requer no mínimo uma letra maiúscula',
  'formValidation.shouldContain-lowerCase':
    'Este campo requer no mínimo uma letra minúscula',
  'formValidation.shouldContain-numbers':
    'Este campo requer no mínimo um número',
  'formValidation.shouldContain-specialCharacters':
    'Este campo requer no mínimo um caractere especial',
  'formValidation.password-dont-match':
    'A senha de confirmação deve ser indêntica a nova senha.',
  'formValidation.password-requirements':
    'A nova senha deve ter ao menos 8 caracteres, com ao menos uma letra minúscula, uma letra maiúscula, um número e um caractere especial.',
};

export default formValidation;
